import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import styles from "./EventSnapshotItem.module.css";

import NoteIcon from "DreamStream/Shared/NoteIcon";
import Button from "shared/Button";

export function EventSnapshotItem({ eventSnapshotInfo, onClick, onNoteClick }) {
  return (
    <li className={styles.container}>
      {Object.entries(eventSnapshotInfo).map((pair) =>
        pair[0] !== "notes" ? (
          <p className={styles[pair[0]]}>{String(pair[1])}</p>
        ) : null
      )}
      <div
        className={classNames(styles.note, {
          [styles.null]: !eventSnapshotInfo.notes,
        })}
      >
        <NoteIcon onClick={onNoteClick ? onNoteClick : null} />
      </div>

      <div className={styles.item}>
        <Button
          type="button"
          className={styles.detailsBtn}
          onClick={onClick}
          size="small"
        >
          Details
        </Button>
      </div>
    </li>
  );
}

EventSnapshotItem.propTypes = {
  /**
   * Object with the snapshot's info.
   */
  eventSnapshotInfo: PropTypes.shape({
    fileName: PropTypes.string,
    createdOn: PropTypes.string,
    eventName: PropTypes.string,
    totalUsers: PropTypes.string,
    notes: PropTypes.string,
  }),
  /**
   * Function that fires when the details button is clicked.
   */
  onClick: PropTypes.func,
  /**
   * Function that fires when the notes button is clicked.
   * If null, the notes button does not do anything.
   */
  onNoteClick: PropTypes.func,
};
